// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d7261c6","455":"52e84db3","977":"ff2dd38a"}[chunkId] + ".chunk.js";
};